module.exports = __webpack_public_path__ + "img/cz.675b5be5.svg";